import React from 'react'
import PropTypes from 'prop-types'

import { selectors as ApplicationsSelectors } from 'data/applications'

import ApplicationEntry from '../components/ApplicationEntry'
import BackToIntegrations from '../components/BackToIntegrations'
import { Text } from 'components/base'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import providesPaginatedApplications from '../dataSync/providesPaginatedApplications'

class ListapplicationsPage extends React.Component {
  static propTypes = {
    applications: PropTypes.array.isRequired,
  }

  componentDidMount() {
    this.props.fetchNextPage({ startFresh: true })
  }

  render() {
    return (
      <React.Fragment>
        <BackToIntegrations />

        <Text.Subtitle className="margin-bottom-medium">
          Integrate with other apps
        </Text.Subtitle>
        <div>
          {this.props.applications.map((application, index) => (
            <ApplicationEntry {...application} key={index} />
          ))}
        </div>
      </React.Fragment>
    )
  }
}

export default compose(
  providesPaginatedApplications(),
  connect(state => {
    return {
      applications: ApplicationsSelectors.getAllApplications(state),
    }
  })
)(ListapplicationsPage)
